import { Injectable } from "@angular/core";
import { Actions, concatLatestFrom, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppError, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { groupSwitchMap } from "@obg/ngx.global";
import { isEmpty } from "lodash-es";
import { merge, of } from "rxjs";
import { catchError, map, mergeMap, take, tap } from "rxjs/operators";

import { CoreContentState } from "../state";

import { TranslationAction } from "./translation.action";
import { translationMessageContext } from "./translation.const";
import { TranslationSelector } from "./translation.selector";
import { TranslationService } from "./translation.service";

/**
 * @deprecated - [fabric-deprecated]
 */
@Injectable()
export class TranslationEffect {
	/**
	 * @deprecated - [fabric-deprecated]
	 */
	init$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(TranslationAction.init),
				concatLatestFrom(() => this.store.select(this.selector.getAllTranslations())),
				tap(([{ payload }, translations]) => {
					this.service.init(payload);
					if (translations) {
						this.service.set(translations);
					}
				})
			),
		{ dispatch: false }
	);

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentValue.getTranslationGroups) instead
	 */
	get$ = createEffect(() =>
		this.actions$.pipe(
			ofType(TranslationAction.get),
			mergeMap(({ payload }) => this.store.select(this.selector.filteredGroups(payload)).pipe(take(1))),
			groupSwitchMap((filteredGroups) =>
				this.service.getTranslationGroupByNames(filteredGroups).pipe(
					take(1),
					tap((translations) => {
						if (!isEmpty(translations)) {
							this.service.set(translations!);
						}
					}),
					map((translations) =>
						TranslationAction.getSuccess({
							groups: filteredGroups,
							translations: translations || {},
						})
					),
					catchError((response: AppError) => of(TranslationAction.getFail(response)))
				)
			)
		)
	);

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	initMessages$ = createEffect(
		() =>
			merge(
				this.messageService.mapErrorByContext$(
					{
						[TranslationAction.getFail.type]: translationMessageContext.get,
					},
					MessageScopeType.Global,
					MessageType.Fatal
				),
				this.messageService.mapClearByContext$({
					[TranslationAction.init.type]: translationMessageContext.initialize,
					[TranslationAction.get.type]: translationMessageContext.get,
				})
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private service: TranslationService,
		private selector: TranslationSelector,
		private store: Store<CoreContentState>,
		private messageService: MessageService
	) {}
}
